export default __webpack_public_path__ + "static/media/Redwood_LEEDOM_Premios Impulso SUMe.716e6b4b.pdf";